import { pageViewTypes } from "@constants/tracking";
import FaqsContainer from "@features/faqs/components/FaqsContainer";
import { dialogTexts } from "@features/faqs/constants";
import useAnalytics from "@hooks/useAnalytics";
import Box from "@memorang/ui/src/components/Box";
import ModalHeader from "components/ModalHeader";
import { Stack } from "expo-router";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const FaqsRoute = () => {
	const config = dialogTexts.faqs;
	const { t } = useTranslation();

	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.faq,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);

	return (
		<>
			<Stack.Screen
				options={{
					presentation: "modal",
					headerShown: true,
					header: () => (
						<ModalHeader backIcon="arrow-left" headerTitle={t(config.title)} />
					),
				}}
			/>
			<Box padding={16} paddingBottom={84}>
				<FaqsContainer />
			</Box>
		</>
	);
};

export default FaqsRoute;
